import {Routes} from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
  },
  {
    path: 'comparateur',
    loadComponent: () => import('./pages/comparator-form/comparator-form.component').then(m => m.ComparatorFormComponent),
  },
  {
    path: 'comparateur/results/:id',
    loadComponent: () => import('./pages/results-page/results-page.component').then(m => m.ResultsPageComponent),
  },
  {
    path: 'comparateur/:id',
    loadComponent: () => import('./pages/comparator-form/comparator-form.component').then(m => m.ComparatorFormComponent),

  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
